import { IPatientListDto } from 'src/services/api/api-client';

export type PatientDataType = Pick<
  IPatientListDto,
  'id' | 'uniqueId' | 'firstTherapyDay' | 'lastTherapyDay' | 'studyStartedAt' | 'studyFinishedAt'
>;

export enum DateRangeEnum {
  Week,
  Month,
  Year,
}
